import { ThingLDSchema, WithLDSchemaContext } from '@gik/seo';

export default function withJSONLDSchemaContext<T extends ThingLDSchema = ThingLDSchema>(t: T): WithLDSchemaContext<T> {
  return {
    '@context': 'https://schema.org',
    ...(t as object),
  } as WithLDSchemaContext<T>;
}
